/**
 * Dropdown options for Detailed Fabric Analysis fields (Step 1 - Generate Kit)
 */

export const WEAVE_OR_KNIT_OPTIONS = [
  'Woven', 'Knitted', 'Non-woven', 'Warp-knitted', 'Weft-knitted', 'Tricot',
  'Jersey knit', 'Rib knit', 'Other'
];

export const FIBER_OPTIONS = [
  'Cotton', 'Polyester', 'Silk', 'Wool', 'Linen', 'Rayon', 'Nylon', 'Viscose',
  'Modal', 'Tencel/Lyocell', 'Spandex/Elastane', 'Acrylic', 'Cashmere', 'Bamboo',
  'Hemp', 'Blend', 'Other'
];

export const OPACITY_OPTIONS = [
  'Opaque', 'Semi-transparent', 'Sheer', 'Translucent', 'Transparent', 'Other'
];

export const STRETCH_OPTIONS = [
  'Stretchy', 'Non-stretch', 'Minimal stretch', 'Moderate stretch', 'High stretch', 'Other'
];

export const GSM_WEIGHT_OPTIONS = [
  'Light Weight (<150 GSM)',
  'Mid Weight (150-260 GSM)',
  'Heavy Weight (260+ GSM)'
];

/** Fabric visual appearance (visual_characteristics.visual_type) */
export const FABRIC_VISUAL_TYPE_OPTIONS = [
  'Solids',
  'Prints',
  'Textured/Jacquard',
  'Corduroy',
  'Sequin',
  'Mesh',
  'Embroidered',
  'Crochet',
  'Other'
];
